<template>
  <v-dialog :value="value" :width="600" @input="$emit('input', $event)">
    <v-card>
      <v-card-title :style="{ flexWrap: 'nowrap' }">
        <h3 v-if="viewedChoice()" class="title ma-0">{{ viewedChoice().question }}</h3>
        <v-btn flat icon left class="ml-auto my-0" @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <table>
        <tbody>
          <tr v-for="(answer, answerIndex) in paginatedAnswers" :key="answerIndex">
            <td class="pa-2">{{ answer }}</td>
          </tr>
        </tbody>
      </table>
      <v-card-actions :style="{ justifyContent: 'center' }">
        <v-pagination v-if="viewedChoice()" v-model="page" :length="totalPages" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  inject: ['viewedChoice'],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      page: 1,
      rowsPerPage: 10
    }
  },
  computed: {
    totalPages() {
      if (!this.viewedChoice()) return 0
      return Math.ceil(this.viewedChoice().answers.length / this.rowsPerPage)
    },
    paginatedAnswers() {
      if (!this.viewedChoice()) return []
      const start = (this.page - 1) * this.rowsPerPage
      const end = start + this.rowsPerPage
      return this.viewedChoice().answers.slice(start, end)
    }
  },
  created() {
    this.$watch(
      () => this.viewedChoice(),
      (value) => {
        if (!value) return
        this.page = 1
      }
    )
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/survey/SurveySummary/SurveySummaryChoiceAnswerListDialog.vue